import { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { AuthGate } from '../components/AuthGate';
import { useAuth } from '../lib/auth';
import { submitVoteResponse } from '../lib/firestore';

const usageOptions = ['Finding what to watch in short breaks', 'Following episodic micro-dramas', 'Discovering anime-style stories'];
const featureOptions = ['More daily reels', 'Episode reminders', 'Creator submissions', 'Community voting'];

function RadioBlock({
  label,
  value,
  options,
  onChange,
}: {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
}) {
  return (
    <fieldset className="vote-block">
      <legend>{label} <span>*</span></legend>
      {options.map((option) => (
        <label className="radio-row" key={option}>
          <input type="radio" name={label} value={option} checked={value === option} onChange={() => onChange(option)} required />
          <span>{option}</span>
        </label>
      ))}
    </fieldset>
  );
}

export function VotePage() {
  const { user, profile } = useAuth();
  const [usage, setUsage] = useState('');
  const [feature, setFeature] = useState('');
  const [suggestion, setSuggestion] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [saved, setSaved] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!user) return;
    setSubmitting(true);
    try {
      await submitVoteResponse({
        uid: user.uid,
        email: user.email || '',
        displayName: profile?.displayName || user.displayName || '',
        usage,
        feature,
        suggestion,
      });
      setSaved(true);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="page-pad">
      <AuthGate title="Login to vote">
        <section className="vote-panel">
          <h1>How will You Make InstaFlix Better?</h1>
          <p>Takes less than 30 seconds.</p>
          {saved && (
            <div className="success-banner">
              <CheckCircle2 size={18} />
              Vote saved. You can update it anytime.
            </div>
          )}
          <form onSubmit={submit}>
            <RadioBlock label="How are you using InstaFlix?" value={usage} options={usageOptions} onChange={setUsage} />
            <RadioBlock label="What feature should we build next?" value={feature} options={featureOptions} onChange={setFeature} />
            <label className="suggestion-box">
              <span>Share your suggestion to improve InstaFlix</span>
              <textarea
                value={suggestion}
                onChange={(event) => setSuggestion(event.target.value)}
                placeholder="What would make InstaFlix awesome for you?"
                rows={5}
              />
            </label>
            <button className="primary-action" type="submit" disabled={submitting || !usage || !feature}>
              {submitting ? 'Saving...' : 'Submit vote'}
            </button>
          </form>
        </section>
      </AuthGate>
    </div>
  );
}
